// Only create consumer in browser environment, not during SSR
import { Consumer, createConsumer } from "@rails/actioncable";

let consumer: Consumer = null

if (!import.meta.env.SSR) {
    consumer = createConsumer()
}

export default consumer